import React from "react";
import { ReactLenis } from "lenis/react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import About from "./pages/About";
import Admission from "./pages/Admission";
import Faculty from "./pages/Faculty";
import Gallery from "./pages/Gallery";
import Achievements from "./pages/Achievements";
import Contact from "./pages/Contact";
import ScrollToTop from "./components/ScrollToTop";

const App = () => (
	<Router>
		<ReactLenis root />
		<ScrollToTop />
		<div className="flex flex-col max-h-dvh">
			<Navbar />
			<main className="flex-grow">
				<Routes>
					<Route path="/" element={<Home />} />
					<Route path="/about" element={<About />} />
					<Route path="/admission" element={<Admission />} />
					<Route path="/faculty" element={<Faculty />} />
					<Route path="/gallery" element={<Gallery />} />
					<Route path="/achievements" element={<Achievements />} />
					<Route path="/contact" element={<Contact />} />
				</Routes>
			</main>
			<Footer />
		</div>
	</Router>
);

export default App;
